import { LeadForm } from '~widgets/lead-form/components/lead-form'
import illustrationDesktop from './images/lead-form-psy.jpg'
import { getProgramData } from '~shared/api/single-program-data/single-program-data'


export const LeadFormPsychologySection = ({ program }: {program: Awaited<ReturnType<typeof getProgramData>>}) => {
  return (
    <section className='py-[56px] 2lg:py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <div className='grid grid-cols-1 2lg:grid-cols-2 gap-[24px] 2lg:gap-[32px]'>

          {/* Image — только на десктопе */}
          <div
            className='hidden 2lg:block w-full h-full rounded-[16px] min-h-[425px]'
            style={{
              backgroundImage: `url(${illustrationDesktop.src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          />

          {/* Lead form */}
          <div className='p-[24px] md:p-[32px] rounded-[16px] bg-[#F5F5F5]'>
            <p className='text-[20px] font-medium leading-[120%] mb-[24px] 2lg:mb-[32px]'>
              Получите полную программу курса на личной консультации
            </p>
            <LeadForm
            buttonWrap
              program={{
                productId: program?.productUid ?? null,
                productName: program?.name ?? '',
                productCategory: program?.category?.name ?? '',
                productFaculty: program?.faculty?.name ?? ''
              }}
            />
          </div>

        </div>
      </div>
    </section>
  )
}